import { accountsClaimsDocumentSlice } from './document/index';
import { accountsClaimsListSlice } from './list/index';
import { combineReducers } from 'redux';

export const claims = combineReducers({
    list: accountsClaimsListSlice.reducer,
    document: accountsClaimsDocumentSlice.reducer,
});
